
import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import SelectStudentFeeModal from "../FeeStudentModal/SelectStudentFeeModal";
import Select from "react-select";
import { Table, Pagination } from "react-bootstrap";
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";
import {
  getFeePeriodCount,
  getFeePeriodLabel,
  isMonthlyFeeFrequency,
  isYearlyFeeFrequency,
} from "../../../utils/feeFrequencyUtils";

const StudentFee = () => {
  const navigate = useNavigate();
  const academicSessionId = localStorage.getItem("academicSessionId") || "1";
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [periodOptions, setPeriodOptions] = useState([]);
  const [feeStructure, setFeeStructure] = useState([]);
  const [studentId, setStudentId] = useState(null);
  const [unpaidElements, setUnpaidElements] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState({
    name: "",
    barcode: "",
    admissionNo: "",
  });
  const [selectedFeeApplied, setSelectedFeeApplied] = useState(null);
  const [elementNameOptions, setElementNameOptions] = useState([]);
  const [feeElement, setFeeElement] = useState({
    name: "",
    element_type_id: null, // For element type
    frequency: "", // For element frequency
    amount: 0,
    periods: Array(6).fill(""),
    adjustment_flag: "N",
    period_month: "",
  });
  const [addedFeeElements, setAddedFeeElements] = useState([]);
  const [frequencyOptions, setFrequencyOptions] = useState([]);
  // const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const MONTH_SEQUENCE = {
    january: 1,
    february: 2,
    march: 3,
    april: 4,
    may: 5,
    june: 6,
    july: 7,
    august: 8,
    september: 9,
    october: 10,
    november: 11,
    december: 12,
  };

  const getPeriodSequence = (periodLabel) => {
    const normalized = String(periodLabel || "").toLowerCase().trim();

    if (!normalized) {
      return 9999;
    }

    const monthName = Object.keys(MONTH_SEQUENCE).find((month) =>
      normalized.includes(month)
    );
    if (monthName) {
      return MONTH_SEQUENCE[monthName];
    }

    const ordinalMatch = normalized.match(/(\d+)\s*(st|nd|rd|th)?/);
    if (ordinalMatch) {
      return 100 + Number.parseInt(ordinalMatch[1], 10);
    }

    return 5000;
  };

  const sortFeeStructureData = (rows) =>
    [...rows].sort((a, b) => {
      const periodDiff =
        getPeriodSequence(a.period_month) - getPeriodSequence(b.period_month);
      if (periodDiff !== 0) {
        return periodDiff;
      }

      const periodLabelDiff = String(a.period_month || "").localeCompare(
        String(b.period_month || "")
      );
      if (periodLabelDiff !== 0) {
        return periodLabelDiff;
      }

      return String(a.element_name || "").localeCompare(
        String(b.element_name || "")
      );
    });

  const handleClear = () => {
    // Clear selected student data
    setSelectedStudent({
      name: "",
      barcode: "",
      admissionNo: "",
      class: "",
      section: "",
    });

    // Clear fee structure table data
    setFeeStructure([]);

    // Clear unpaid elements table data
    setUnpaidElements([]);

    // Clear additional fee elements table data
    setAddedFeeElements([]);

    // Clear Add Fee Element fields data
    setFeeElement({
      name: "", // Reset name field
      element_type_id: null, // Reset element type
      frequency: "", // Reset frequency
      amount: 0, // Reset amount
      periods: Array(6).fill(""), // Reset periods array to empty
      adjustment_flag: "N", // Reset adjustment flag
      period_month: "", // Reset period month
    });
  };
  const handleUpdateCheckboxChange = (
    itemId,
    isChecked,
    value,
    elementName
  ) => {
    setUnpaidElements((prev) =>
      prev.map((detail) => {
        if (detail.element_name === elementName) {
          return {
            ...detail,
            updateflag: detail.id === itemId ? isChecked : false,
            // Only updateamount for the row where checkbox is checked
            updateamount:
              detail.id === itemId && isChecked
                ? parseFloat(value || 0)
                : detail.updateamount,
          };
        }
        return detail;
      })
    );
  };
  

  const handleRemoveCheckboxChange = (itemId, isChecked, elementName) => {
    setUnpaidElements((prev) =>
      prev.map((detail) => {
        if (detail.element_name === elementName) {
          return {
            ...detail,
            removeflag: detail.id === itemId ? isChecked : false,
          };
        }
        return detail;
      })
    );
  };
  


  const handleFeeStructureAmountChange = (itemId, value) => {
    setFeeStructure((prev) =>
      prev.map((item) =>
        item.id === itemId
          ? { ...item, total_element_period_amount: value }
          : item
      )
    );
  };
  
  const handleFeeStructureUpdateCheckbox = (itemId, isChecked) => {
    setFeeStructure((prev) =>
      prev.map((item) =>
        item.id === itemId ? { ...item, updateflag: isChecked } : item
      )
    );
  };
  const handleFeeStructureRemoveCheckbox = (itemId, isChecked) => {
    setFeeStructure((prev) =>
      prev.map((item) =>
        item.id === itemId ? { ...item, removeflag: isChecked } : item
      )
    );
  };
  
  


  const handleAmountChange = (id, value) => {
    setFeeStructure((prevFeeStructure) =>
      prevFeeStructure.map((item) =>
        item.id === id
          ? { ...item, total_element_period_amount: parseFloat(value) || 0 }
          : item
      )
    );
  };

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // const handleSelectStudent = (student) => {
  //   // Update the form with the selected student's data
  //   setSelectedStudent({
  //     barcode: student.studentBasicDetails.barcode,
  //     admissionNo: student.studentBasicDetails.admission_no,
  //     name: student.studentname,
  //     class: student.studentBasicDetails.classname,
  //     section: student.studentBasicDetails.sectionname,
  //   });
  //   handleCloseModal(); // Close modal after selecting the student
  // };
  const handleSelectStudent = (student) => {
    // Update the form with the selected student's data
    setSelectedStudent({
      barcode: student.barcode,
      admissionNo: student.admission_no,
      name: student.studentname, // Full name is already combined in API
      class: student.classname,
      section: student.sectionname,
    });

    handleCloseModal(); // Close modal after selecting the student
  };

  
  const itemsPerPage = 6; // Number of items per page

  const dateRef = useRef(null);
  const fromClassRef = useRef(null);
  const toClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

  // const handleClear = () => {
  //   if (dateRef.current) dateRef.current.value = "";
  //   if (fromClassRef.current) fromClassRef.current.value = "";
  //   if (toClassRef.current) toClassRef.current.value = "";
  //   if (admissionNoRef.current) admissionNoRef.current.value = "";
  //   if (barcodeRef.current) barcodeRef.current.value = "";
  //   if (smsToRef.current) smsToRef.current.checked = false;
  // };

  useEffect(() => {
    const fetchPeriods = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`);
        const data = await response.json();

        if (data.message === "success") {
          const academicYearId = localStorage.getItem("academicSessionId");
          const options = [...data.data]
            .filter(
              (period) =>
                !academicYearId ||
                String(period.academic_id) === String(academicYearId),
            )
            .sort(
              (first, second) =>
                (first.sorting_order ?? first.id) -
                (second.sorting_order ?? second.id),
            )
            .map((period) => ({
              value: period.id,
              label: period.period_name,
            }));
          setPeriodOptions(options);
        }
      } catch (error) {
        console.error("Error fetching periods:", error);
      }
    };

    fetchPeriods();
  }, []);

  const handleAddFeeElement = () => {
    const academicYearId = localStorage.getItem("academicSessionId");
    console.log(studentId, "ggggg");

    const selectedFrequency = frequencyOptions.find(
      (option) => option.value === feeElement.frequency
    );
    const periodCount = getFeePeriodCount(selectedFrequency);
    if (!periodCount) {
      alert("Please select a valid frequency.");
      return;
    }

    const selectedPeriodIds = isMonthlyFeeFrequency(selectedFrequency)
      ? periodOptions.slice(0, 12).map((option) => option.value)
      : feeElement.periods.slice(0, periodCount);

    if (
      !isMonthlyFeeFrequency(selectedFrequency) &&
      selectedPeriodIds.some((periodId) => !periodId)
    ) {
      alert("Please select every required Period Month.");
      return;
    }

    // Add fee element with period IDs
    setAddedFeeElements((prev) => [
      ...prev,
      {
        ...feeElement,
        studentId: studentId, // Replace with actual studentId
        academic_year_id: academicYearId,
        element_name: feeElement.name,
        frequencyId: feeElement.frequency,
        period_month: isYearlyFeeFrequency(selectedFrequency)
          ? selectedPeriodIds[0]
          : null,
        org_id: 1, // Replace with actual org ID
        branch_id: 1, // Replace with actual branch ID
        amount: feeElement.amount,
        periods: selectedPeriodIds,
        period_1: selectedPeriodIds[0] || null,
        period_2: selectedPeriodIds[1] || null,
        period_3: selectedPeriodIds[2] || null,
        period_4: selectedPeriodIds[3] || null,
        period_5: selectedPeriodIds[4] || null,
        period_6: selectedPeriodIds[5] || null,
      },
    ]);

    console.log(addedFeeElements, "kkkkk");
  };

  useEffect(() => {
    // Fetch frequency options from API
    const fetchFrequencyOptions = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}FEEFREQUENCY/GetAllFrequencyPeriodlist/`
        );
        const result = await response.json();
        const options = result.data.map((option) => ({
          value: option.id,
          label: option.FeeFrequencyName,
          feeFrequencyName: option.FeeFrequencyName,
        }));
        setFrequencyOptions(options);
      } catch (error) {
        console.error("Error fetching frequency options:", error);
      }
    };

    fetchFrequencyOptions();
  }, []);

  const handleFrequencyChange = (selectedOption) => {
    if (!selectedOption) {
      setFeeElement((prev) => ({
        ...prev,
        frequency: "",
        frequencyName: "",
        periods: Array(6).fill(null),
      }));
      return;
    }

    const enabledPeriodCount = getFeePeriodCount(selectedOption);
    setFeeElement((prev) => ({
      ...prev,
      frequency: selectedOption.value,
      frequencyName: selectedOption.feeFrequencyName || selectedOption.label,
      periods: prev.periods.map((periodValue, idx) =>
        idx < enabledPeriodCount ? periodValue : null
      ),
    }));

  };

  const handlePeriodMonthChange = (selectedOption) => {
    setFeeElement((prev) => ({
      ...prev,
      period_month: selectedOption ? selectedOption.value : "",
      periods: [
        selectedOption ? selectedOption.value : "",
        ...prev.periods.slice(1),
      ],
    }));
  };

  const handleFeeAppliedChange = (option) => {
    setSelectedFeeApplied(option);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: "100%",
    }),
  };

  const handleChange = (selected) => {
    setSelectedOption(selected);
  };

  // Sample data for the table

  useEffect(() => {
    const fetchFeeElements = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}FEE_ELEMENT_TYPE/GetAllFeeElements/S`
        );
        const result = await response.json();

        if (result.message === "success") {
          const options = result.data.map((element) => ({
            value: element.id,
            label: element.element_name,
          }));
          setElementNameOptions(options);
        }
      } catch (error) {
        console.error("Error fetching fee elements:", error);
      }
    };

    fetchFeeElements();
  }, []);


  const handleSearch = async () => {
    const id = selectedStudent?.id || "";
    const barcode = selectedStudent?.barcode
      ? String(selectedStudent.barcode).trim()
      : "";
    const admissionNo = selectedStudent?.admissionNo
      ? String(selectedStudent.admissionNo).trim()
      : "";

    if (!id && !barcode && !admissionNo) {
      console.error(
        "Please enter at least one search criterion (Student ID, Barcode, )."
      );
      return;
    }

    // Construct the query string based on available parameters
    const queryParams = new URLSearchParams();
    if (id) queryParams.append("studentId", id);
    if (barcode) queryParams.append("barcode", barcode);
    if (admissionNo) queryParams.append("schooladmissionno", admissionNo);
    queryParams.append("flag", "N"); // Assuming 'flag=Y' is a required constant

    const url = `${
      ApiUrl.apiurl
    }FILTER/GetFilterSTUDENTfilterdatabasedoncondition?${queryParams.toString()}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      const result = await response.json();

      if (response.ok && result.message === "success!!" && result.data) {
        const retrievedStudentId = result.data.studentId;
        setStudentId(retrievedStudentId); // Set student ID in state

        // Retrieve the academic session ID from localStorage
        const academicSessionId =
          localStorage.getItem("academicSessionId") || "1";

        // Fetch fee structure for the retrieved student ID
        const feeResponse = await fetch(
          `${ApiUrl.apiurl}FeeStructureDetails/GetFeeStructureBasedOnStudent/${retrievedStudentId}/${academicSessionId}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );

        const feeResult = await feeResponse.json();

        if (feeResponse.ok && feeResult.message === "success") {
          const sortedFeeStructure = sortFeeStructureData(feeResult.data || []);
          setFeeStructure(sortedFeeStructure);

        const unpaidElementsData = sortedFeeStructure
          .filter((item) => parseFloat(item.paid_amount) === 0)
          .reduce((uniqueElements, item) => {
            const isDuplicate = uniqueElements.some(
              (el) =>
                el.element_name === item.element_name &&
                parseFloat(el.total_element_period_amount) ===
                  parseFloat(item.total_element_period_amount)
            );

            if (!isDuplicate) {
              uniqueElements.push({
                ...item,
                updateflag: false,
                removeflag: false,
                updateamount: "",
              });
            }

            return uniqueElements;
          }, []);


          setUnpaidElements(unpaidElementsData); // Store unique unpaid elements
        } else {
          setFeeStructure([]);
          setUnpaidElements([]);
          console.error("No fee structure found for the given student.");
        }
      } else {
        setSearchResults([]);
        console.error(
          "No student found with the given details or error in response."
        );
      }
    } catch (error) {
      console.error("Error fetching student or fee structure data:", error);
    }
  };


  const handleSave = async () => {
    try {
      // Get org_id, branch_id from localStorage and loginUser from sessionStorage
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const userId = sessionStorage.getItem("userId");

      // Validate that orgId, branchId, userId, and studentId exist
      if (!orgId || !branchId || !userId) {
        alert(
          "Required values are missing from localStorage or sessionStorage."
        );
        return;
      }

      // Ensure studentId is selected
      if (!studentId) {
        alert("Select student first");
        return;
      }

      // Prepare studentIndividualFeeDetails array
      const studentIndividualFeeDetails = feeStructure.map((item) => ({
        studentfeedetailsId: item.id,
        updateamount: parseFloat(item.total_element_period_amount),
        updateflag: item.updateflag || false,
        removeflag: item.removeflag || false,
      }));

      // Prepare studentFeeDetails array
      const studentFeeDetails = unpaidElements.map((item) => ({
        Feeelement: item.element_name || "DefaultElement",
        studentId: studentId,
        academicyearId: academicSessionId,
        updateamount: parseFloat(item.updateamount) || 0,
        updateflag: item.updateflag || false,
        removeflag: item.removeflag || false,
      }));

      // Prepare addfeeElement array
      const addfeeElement = addedFeeElements.map((element) => {
        const periodIds = element.periods || [];
        const isMonthly = isMonthlyFeeFrequency(element.frequencyName);
        const isYearly = isYearlyFeeFrequency(element.frequencyName);

        return {
          studentId: studentId,
          academic_year_id: academicSessionId,
          element_name: element.name,
          frequencyId: element.frequencyId,
          period_month: isYearly ? periodIds[0] || null : null,
          org_id: orgId, // Use orgId from localStorage
          branch_id: branchId, // Use branchId from localStorage
          amount: parseFloat(element.amount),
          period_1: isMonthly ? null : periodIds[0] || null,
          period_2: isMonthly ? null : periodIds[1] || null,
          period_3: isMonthly ? null : periodIds[2] || null,
          period_4: isMonthly ? null : periodIds[3] || null,
          period_5: isMonthly ? null : periodIds[4] || null,
          period_6: isMonthly ? null : periodIds[5] || null,
        };
      });

      // Payload to be sent
      const payload = {
        loginUser: userId, // Use userId from sessionStorage
        studentIndividualFeeDetails,
        studentFeeDetails,
        addfeeElement,
      };

      // Make API call to save data
      const response = await fetch(
        `${ApiUrl.apiurl}STUDENTFEEDETAILS/StudentFeesManagement/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Save successful:", data);

      // Alert for successful save
      alert("Data saved successfully!");

      setSelectedStudent({
        name: "",
        barcode: "",
        admissionNo: "",
        class: "",
        section: "",
      });

      // Clear fee structure table data
      setFeeStructure([]);

      // Clear unpaid elements table data
      setUnpaidElements([]);

      // Clear additional fee elements table data
      setAddedFeeElements([]);

      // Clear Add Fee Element fields data
      setFeeElement({
        name: "", // Reset name field
        element_type_id: null, // Reset element type
        frequency: "", // Reset frequency
        amount: 0, // Reset amount
        periods: Array(6).fill(""), // Reset periods array to empty
        adjustment_flag: "N", // Reset adjustment flag
        period_month: "", // Reset period month
      });

      // Fetch updated fee structure after save
      const feeStructureResponse = await fetch(
        `${ApiUrl.apiurl}FeeStructureDetails/GetFeeStructureBasedOnStudent/${studentId}/${academicSessionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!feeStructureResponse.ok) {
        throw new Error(`HTTP error! status: ${feeStructureResponse.status}`);
      }

      const updatedFeeStructure = await feeStructureResponse.json();
      console.log("Updated Fee Structure:", updatedFeeStructure);

      // Update the fee structure state with the fetched data
      setFeeStructure(sortFeeStructureData(updatedFeeStructure.data || []));
    } catch (error) {
      console.error("Error saving data:", error);

      // Alert in case of an error
      alert("Failed to save data. Please try again.");
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const maxAddedPeriodCount = Math.max(
    1,
    ...addedFeeElements.map((element) => {
      const periodCount = getFeePeriodCount(element.frequencyName);
      return Math.min(
        element.periods?.length || 0,
        periodCount || 6,
      );
    }),
  );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT FEE DETAILS
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-4 mb-3">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-name"
                            className="form-control detail"
                            placeholder="Enter student name"
                            ref={admissionNoRef}
                            value={selectedStudent.name}
                            readOnly
                          />
                          {/* <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button> */}

                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>

                      <SelectStudentFeeModal
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelectStudent={handleSelectStudent}
                      />

                      <div className="col-12 col-md-4 mb-1">
                        <label htmlFor="student-barcode" className="form-label">
                          Student BarCode
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-barcode"
                            className="form-control detail"
                            placeholder="Enter student barcode"
                            ref={barcodeRef}
                            value={selectedStudent.barcode}
                            onChange={(e) =>
                              setSelectedStudent({
                                ...selectedStudent,
                                barcode: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>


                      <div className="col-12 col-md-4 mb-3">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="class"
                            className="form-control detail"
                            placeholder="Enter class name"
                            ref={admissionNoRef}
                            value={selectedStudent.class}
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-4 mb-1">
                        <label htmlFor="period" className="form-label">
                          Section
                        </label>
                        <input
                          type="text"
                          id="period"
                          className="form-control detail"
                          placeholder="Enter section"
                          value={selectedStudent.section}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Row for side-by-side tables */}
              <div className="row mt-3">
                <div className="col-md-6 ">
                  <h5>Element Details</h5>
                  <div
                    className="table-responsive"
                    style={{
                      maxHeight: "700px", // Set the maximum height for the scrollable area
                      overflowY: "auto", // Enable vertical scrolling
                    }}
                  >
                    <table className="table table-bordered table-striped">
                      <thead className="table-light">
                        <tr>
                          <th>Period Month</th>
                          <th>Element Name</th>
                          <th>Amount</th>
                          <th>Paid Amount</th>
                          <th>Update Amount</th>
                          <th>Update</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {feeStructure.length > 0 ? (
                          feeStructure.map((item) => (
                            <tr
                              key={item.id}
                              style={{
                                opacity: item.paid_amount > "0.00" ? 0.5 : 1,
                              }}
                            >
                              <td>{item.period_month}</td>
                              <td>{item.element_name}</td>
                              <td>{item.total_element_period_amount}</td>
                              <td>{item.paid_amount}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control detail"
                                  value={item.total_element_period_amount}
                                  disabled={parseFloat(item.paid_amount) > 0}
                                  onChange={(e) =>
                                    handleFeeStructureAmountChange(
                                      item.id,
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={item.updateflag || false}
                                  disabled={parseFloat(item.paid_amount) > 0}
                                  onChange={(e) =>
                                    handleFeeStructureUpdateCheckbox(
                                      item.id,
                                      e.target.checked
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={item.removeflag || false}
                                  disabled={parseFloat(item.paid_amount) > 0}
                                  onChange={(e) =>
                                    handleFeeStructureRemoveCheckbox(
                                      item.id,
                                      e.target.checked
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7">No fee structure data available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-section">
                    <h5>Elements</h5>
                    <Table bordered responsive>
                      <thead>
                        <tr>
                          <th>Element Name</th>
                          <th>Element Amount</th>
                          <th>Update Amount</th>
                          <th>Update</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {unpaidElements.length > 0 ? (
                          unpaidElements.map((item, index) => (
                            <tr key={index}>
                              {" "}
                              {/* Use index if item.id is undefined */}
                              <td>{item.element_name}</td>{" "}
                              {/* Ensure `element_name` is available */}
                              <td>{item.total_element_period_amount}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control detail"
                                  value={item.updateamount || ""}
                                  // Only editable if checkbox selected
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    setUnpaidElements((prev) =>
                                      prev.map((detail) =>
                                        detail.id === item.id
                                          ? {
                                              ...detail,
                                              updateamount: newValue,
                                            }
                                          : detail
                                      )
                                    );
                                  }}
                                />
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={item.updateflag}
                                  onChange={(e) =>
                                    handleUpdateCheckboxChange(
                                      item.id,
                                      e.target.checked,
                                      item.updateamount,
                                      item.element_name
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={item.removeflag}
                                  onChange={(e) =>
                                    handleRemoveCheckboxChange(
                                      item.id,
                                      e.target.checked,
                                      item.element_name
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7">No unpaid elements found</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Add Fee Elements Section */}
                  <div
                    className="form-section"
                    style={{
                      border: "1px solid #808080", // Border color
                      padding: "20px", // Space inside the border
                      margin: "20px 0", // Space outside the border
                    }}
                  >
                    <h5>Add Fee Elements</h5>
                    <form className="row g-3">
                      {/* Left Side: Form Fields */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="element" className="form-label">
                            Element
                          </label>

                          <Select
                            options={elementNameOptions}
                            className="detail"
                            value={
                              elementNameOptions.find(
                                (option) =>
                                  option.value === feeElement.element_type_id
                              ) || null
                            } // Handle null selection
                            onChange={(selectedOption) => {
                              setFeeElement((prev) => ({
                                ...prev,
                                element_type_id: selectedOption.value,
                                name: selectedOption.label,
                              }));
                            }}
                          />
                        </div>

                        <div className="mb-3">
                          <label htmlFor="frequency" className="form-label">
                            Frequency
                          </label>

                          <Select
                            options={frequencyOptions}
                            className="detail"
                            value={
                              frequencyOptions.find(
                                (option) =>
                                  option.value === feeElement.frequency
                              ) || null
                            } // Handle null selection
                            onChange={handleFrequencyChange}
                          />
                        </div>

                        {isYearlyFeeFrequency(
                          frequencyOptions.find(
                            (option) => option.value === feeElement.frequency,
                          ),
                        ) && (
                          <div className="mb-3">
                            <label htmlFor="periodMonth" className="form-label">
                              Period Month
                            </label>
                            <Select
                              options={periodOptions}
                              className="detail"
                              value={
                                periodOptions.find(
                                  (option) => option.value === feeElement.periods[0],
                                ) || null
                              }
                              onChange={handlePeriodMonthChange}
                              placeholder="Select Month"
                            />
                          </div>
                        )}
                        <div className="mb-3">
                          <label htmlFor="amount" className="form-label">
                            Amount
                          </label>
                          <input
                            type="text"
                            id="amount"
                            className="form-control detail"
                            placeholder="Amount"
                            value={feeElement.amount}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            onChange={(e) =>
                              setFeeElement((prev) => ({
                                ...prev,
                                amount: parseFloat(e.target.value) || "",
                              }))
                            }
                          />
                        </div>

                        <div className="col-12">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAddFeeElement}
                          >
                            Add
                          </button>
                        </div>
                      </div>

                      <div className="col-md-6">
                        {getFeePeriodCount(
                          frequencyOptions.find(
                            (option) => option.value === feeElement.frequency,
                          ),
                        ) > 1 &&
                        !isMonthlyFeeFrequency(
                          frequencyOptions.find(
                            (option) => option.value === feeElement.frequency,
                          ),
                        ) && (
                          <>
                            <h6>Period Months</h6>
                            <div className="row g-3">
                          {Array.from({
                            length: getFeePeriodCount(
                              frequencyOptions.find(
                                (option) => option.value === feeElement.frequency,
                              ),
                            ),
                          }).map((_, idx) => (
                            <div className="col-md-6 mb-3" key={idx}>
                              <label
                                htmlFor={`period${idx + 1}`}
                                className="form-label"
                              >
                                Period Month {idx + 1}
                              </label>
                              <Select
                                id={`period${idx + 1}`}
                                className="detail"
                                options={periodOptions}
                                value={
                                  periodOptions.find(
                                    (option) =>
                                      option.value === feeElement.periods[idx]
                                  ) || null
                                }
                                onChange={(selectedOption) => {
                                  const updatedPeriods = [
                                    ...feeElement.periods,
                                  ];
                                  updatedPeriods[idx] = selectedOption
                                    ? selectedOption.value
                                    : "";

                                  setFeeElement({
                                    ...feeElement,
                                    periods: updatedPeriods,
                                  });
                                }}
                                classNamePrefix="react-select"
                                placeholder="Select"
                              />
                            </div>
                          ))}
                            </div>
                          </>
                        )}
                      </div>
                    </form>
                  </div>

                  {/* Second Table for Added Fee Elements */}
                </div>

                <div className="additional-element-table">
                  <h5>Additional Element Details</h5>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead className="table-light">
                        <tr>
                          <th>Sl. No.</th>
                          <th>Element Name</th>
                          <th>Element Frequency</th>
                          <th>Amount</th>
                          {Array.from({ length: maxAddedPeriodCount }).map(
                            (_, periodIdx) => (
                              <th key={`period-header-${periodIdx}`}>
                                Period Month {periodIdx + 1}
                              </th>
                            ),
                          )}
                          <th>Remove</th>
                        </tr>
                      </thead>

                      <tbody>
                        {addedFeeElements.map((element, idx) => (
                          <tr key={`${element.id}-${idx}`}>
                            <td>{idx + 1}</td>
                            <td>{element.name}</td>
                            <td>{element.frequencyName}</td>
                            <td>{element.amount}</td>
                            {Array.from({ length: maxAddedPeriodCount }).map(
                              (_, periodIdx) => {
                                const periodId = element.periods?.[periodIdx];
                                const periodOption = periodOptions.find(
                                  (option) => option.value === periodId,
                                );
                                return (
                                  <td key={`${element.id}-period-${periodIdx}`}>
                                    {getFeePeriodLabel(
                                      periodOption,
                                      element.frequencyName,
                                      periodIdx,
                                    )}
                                  </td>
                                );
                              },
                            )}
                            <td>
                              <a
                                href="#"
                                className="text-danger"
                                onClick={() => {
                                  setAddedFeeElements((prevElements) =>
                                    prevElements.filter((_, i) => i !== idx)
                                  );
                                }}
                              >
                                Remove
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentFee;
